



































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class ComponentBenefitsPaid extends Vue { //E
  @Prop({required: true})
  private postPredict!: {};

  @Prop({required: true})
  private objJson!: string;

  @Prop({default: ''})
  private pageName!: string ;

  @Prop({default: false})
  private reSetData!: boolean ;
}
